var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSecondaryConsumerIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9095_26181)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#7588F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8863 12.8744C16.7227 12.8744 19.022 11.8951 19.022 10.6872C19.022 9.47924 16.7227 8.5 13.8863 8.5C11.0499 8.5 8.75061 9.47924 8.75061 10.6872C8.75061 11.8951 11.0499 12.8744 13.8863 12.8744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2273 15.9803C13.6288 15.1 14.2314 14.3397 14.9754 13.7594C14.6148 13.7913 14.2504 13.8128 13.8852 13.8128C11.8851 13.8128 9.87326 13.3338 8.74951 12.4084V13.8128C8.75042 14.9256 10.7034 15.8425 13.2273 15.9803Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6773 18.5003C12.6773 17.9434 12.757 17.4053 12.8966 16.8934C11.2445 16.7621 9.68755 16.3056 8.75049 15.5331V16.9375C8.75049 17.9725 10.4388 18.8368 12.7054 19.0646C12.6881 18.8781 12.6773 18.6906 12.6773 18.5003Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4174 13.4996C15.7521 13.4996 13.5844 15.7431 13.5844 18.4993C13.5844 21.2556 15.7521 23.4999 18.4174 23.4999C21.0827 23.4999 23.2504 21.2565 23.2504 18.5003C23.2504 15.744 21.0818 13.4996 18.4174 13.4996ZM18.1872 18.0315H18.6467C19.3526 18.0315 19.9272 18.6259 19.9272 19.3562C19.9272 20.0134 19.4695 20.5534 18.8696 20.664V21.1562C18.8696 21.4149 18.6666 21.6249 18.4165 21.6249C18.1664 21.6249 17.9634 21.4149 17.9634 21.1562V20.6874H17.3598C17.1097 20.6874 16.9067 20.4774 16.9067 20.2187C16.9067 19.9599 17.1097 19.7499 17.3598 19.7499H18.6467C18.8533 19.7499 19.0209 19.5756 19.0209 19.3628C19.0209 19.1434 18.8524 18.969 18.6467 18.969H18.1872C17.4812 18.969 16.9067 18.3746 16.9067 17.6443C16.9067 16.9871 17.3643 16.4471 17.9643 16.3365V15.8443C17.9643 15.5856 18.1673 15.3756 18.4174 15.3756C18.6675 15.3756 18.8705 15.5856 18.8705 15.8443V16.3131H19.475C19.7251 16.3131 19.9281 16.5231 19.9281 16.7818C19.9281 17.0406 19.7251 17.2506 19.475 17.2506H18.1881C17.9815 17.2506 17.8138 17.4249 17.8138 17.6378C17.8129 17.8571 17.9815 18.0315 18.1872 18.0315Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9095_26181",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9095_26181"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSecondaryConsumerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/secondary_consumer_icon.cdca71a3fc24bf1b93547ae4423d9943.svg";